module.exports = ".MensagemNulo {\r\n    padding-top: 1em;\r\n}\r\n"